export default __webpack_public_path__ + "static/media/pic94.d6ba954a.jpg";